import axios from "axios";

const DEBUG = process.env.NODE_ENV === 'development';

const http = axios.create({
    baseURL: DEBUG ? `http://127.0.0.1:5001/unaffected-co/us-central1/api` : 'https://us-central1-unaffected-co.cloudfunctions.net/api'
});

export default http;
